import { render, staticRenderFns } from "./web_ide_link.vue?vue&type=template&id=19b2f26a"
import script from "./web_ide_link.vue?vue&type=script&lang=js"
export * from "./web_ide_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports